import React, { useRef, useState } from "react";
import "./carousel.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { SliderH } from "../../../services/script";

const TradnityCarousel = (props) => {
  const [loadingCarousel, setLoadingCarousel] = useState(true);
  const [sliderHeight, setSliderHeight] = useState(null);

  const { image } = props;
  const counter = useRef(0);

  const imageLoaded = (e) => {
    if (counter.current === 0 && e?.target) {
      setSliderHeight(e.target.offsetHeight);
    }
    counter.current += 1;
    if (counter.current >= 1) {
      setLoadingCarousel(false);
    }
  };

  const hasImages =
    image &&
    image.sliderImages &&
    image.sliderImages.data &&
    image.sliderImages.data.length !== 0;

  return (
    <>
      <section className="p-0 small-slider" style={{ position: "relative" }}>

        {/* Dark Luxury Skeleton Loader */}
        {loadingCarousel && (
          <div
            className="carousel-skeleton"
            style={{
              width: "100%",
              margin: "0",
              height: sliderHeight ? `${sliderHeight}px` : "clamp(180px, 45vw, 650px)",
              borderRadius: "0",
              overflow: "hidden",
              position: "relative",
              backgroundColor: "#0d0f12",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="skeleton-shimmer" />
            <div
              style={{
                position: "relative",
                zIndex: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0.7,
                pointerEvents: "none",
              }}
            >
              <svg width="42" height="42" viewBox="0 0 24 24" fill="none" style={{ marginBottom: 10 }}>
                <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="#F5B96D" />
              </svg>
              <div
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "clamp(1.1rem, 2.5vw, 1.5rem)",
                  letterSpacing: "0.25em",
                  color: "#F5B96D",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                SHANZ BY SHANZAY
              </div>
              <div
                style={{
                  fontSize: "0.75rem",
                  letterSpacing: "0.18em",
                  color: "rgba(252, 254, 253, 0.45)",
                  marginTop: 4,
                  textTransform: "uppercase",
                }}
              >
                Luxury Jewellery Collection
              </div>
            </div>
          </div>
        )}

        {/* Hidden pre-loader to measure real image height */}
        {hasImages && loadingCarousel && (
          <img
            src={image.sliderImages.data[0].image_url}
            alt=""
            aria-hidden="true"
            onLoad={imageLoaded}
            style={{
              position: "absolute",
              opacity: 0,
              pointerEvents: "none",
              width: "100%",
              height: "auto",
              top: 0,
              left: 0,
            }}
          />
        )}

        <Slider
          {...SliderH}
          className="slide-1 home-slider"
          style={loadingCarousel ? { display: "none" } : {}}
        >
          {hasImages ? (
            image.sliderImages.data.map((img, key) => (
              <div key={key}>
                <Link
                  to={
                    img?.slider_product == 1
                      ? "/products"
                      : {
                        pathname: `/products/${img?.category_name
                          ?.toLowerCase()
                          .replace(/\s+/g, "-")}-${img?.slider_product}`,
                        state: {
                          categories: {
                            id: img?.slider_product,
                            image_url: img?.category_image,
                            name: img?.category_name,
                          },
                        },
                      }
                  }
                >
                  <img
                    width="100%"
                    className="carouselImg"
                    src={img.image_url}
                    onLoad={key === 0 ? imageLoaded : undefined}
                    alt="Slider"
                  />
                </Link>
              </div>
            ))
          ) : (
            <div
              style={{
                width: "100%",
                height: "clamp(240px, 45vw, 650px)",
                backgroundColor: "#0d0f12",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <div className="skeleton-shimmer" />
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0.7,
                  pointerEvents: "none",
                }}
              >
                <svg width="42" height="42" viewBox="0 0 24 24" fill="none" style={{ marginBottom: 10 }}>
                  <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="#F5B96D" />
                </svg>
                <div
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: "clamp(1.1rem, 2.5vw, 1.5rem)",
                    letterSpacing: "0.25em",
                    color: "#F5B96D",
                    textTransform: "uppercase",
                    fontWeight: 600,
                  }}
                >
                  SHANZ BY SHANZAY
                </div>
              </div>
            </div>
          )}
        </Slider>
      </section>
    </>
  );
};

export default TradnityCarousel;